import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetTableCount} from '@features/home/http/home.http.ts'
import {TableCounters, TableCountersSearchParams} from '@features/home/types.ts'
import {ResponseType} from '@/types.ts'

export const useTableCounts = (
    params: Omit<TableCountersSearchParams, 'response_type'>,
    options?: Omit<UseQueryOptions<TableCounters>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT, QUERY_KEYS.HOME_TABLE, params],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetTableCount({params: {...params, response_type: ResponseType.Enum.extended}}),
                onZodError: captureException,
                responseShape: TableCounters
            }),
        ...options
    })
}
